module.exports = __webpack_public_path__ + "assets/img/shouhuan_icon.1f1a423a.png";